import CustomDrawer from "../../../components/shared/CustomDrawer";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SpecialBonusIcon } from "../../../assets/icons/special-bonus.svg";
import { BalootUserV2APIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import { useEffect, useState } from "react";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";

export function ReferralRuleDrawer(props) {
  const { open, setOpen, campaignId } = props;
  const {
    loading,
    apiCall: campaignStep,
    result,
  } = useRequest(BalootUserV2APIs.getCampaignStep, true);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    campaignStep({
      data: { campaignId },
      onSuccess: (response) => {
        setSteps(response.steps);
      },
    });
  }, []);

  return (
    <CustomDrawer
      containerSx={{
        height: "100vh",
        position: "relative",
        alignItems: "center",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
      }}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          position: "relative",
        }}
      >
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          <CloseIcon sx={{ color: "grey.1" }} />
        </IconButton>
        <Typography
          variant="h4"
          pt="12px"
          color="grey.2"
          sx={{ flex: "1", textAlign: "center" }}
        >
          جزییات پیشنهاد جایزه
        </Typography>
      </Box>

      {loading ? (
        <>
          <CustomRectangularSkeleton sx={{ mt: 2 }} height={200} />
          <CustomRectangularSkeleton sx={{ mt: 2 }} height={200} />
          <CustomRectangularSkeleton sx={{ mt: 2 }} height={200} />
        </>
      ) : (
        <Box>
          {steps &&
            steps.length > 0 &&
            steps.map((item) => (
              <Box key={item.id}>
                <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
                  <SpecialBonusIcon width={24} height={24} />
                  <Typography ml={1} variant="h4" color="grey.2">
                    {item.title}
                  </Typography>
                </Box>
                <Typography
                  mt={1.5}
                  variant="body2"
                  color="grey.8"
                  sx={{ whiteSpace: "pre-line" }}
                >
                  {item.description}
                </Typography>
              </Box>
            ))}
        </Box>
      )}
    </CustomDrawer>
  );
}
